import {PropertyValues} from "lit-element";
import { fireEvent } from "../../Aspect/util";

export {
  InitClickAway,
  initClickAway,
};


interface EmitClickAway extends Element {
  emitClickAwayActive: boolean;
}

interface InitClickAway {
  updated(_changedProperties: PropertyValues): void,
  disconnect(): void,
}

function initClickAway<E extends EmitClickAway>(thisEl: E): InitClickAway {
  return {
    updated,
    disconnect,
  };

  function updated(_changedProperties: PropertyValues<E>): void {
    if (_changedProperties.has("emitClickAwayActive")) {
      if (thisEl.emitClickAwayActive) {
        _addClickAwayListener();
      } else {
        _removeClickAwayListener();
      }
    }
  }
  function disconnect(): void {
    _removeClickAwayListener();
  }

  function _addClickAwayListener() {
    document.body.addEventListener("pointerdown", _onClickAway);
  }

  function _removeClickAwayListener() {
    document.body.removeEventListener("pointerdown", _onClickAway);
  }

  function _onClickAway(event: Event) {
    const targetIsNotCustomElement = event.target instanceof Element && !thisEl.isEqualNode(event.target) && !thisEl.contains(event.target);
    targetIsNotCustomElement && fireEvent(thisEl, "clickAway");
  }
}
